import React from "react";
import { FunnelChart, Funnel, LabelList, ResponsiveContainer, Tooltip } from "recharts";
import { GrcCard, fmtDate } from "@/components/grc/shared";

const PHASES = [
  { key: "phase_1", label: "Phase 1", color: "#D32F2F" },
  { key: "phase_2", label: "Phase 2", color: "#F57C00" },
  { key: "phase_3", label: "Phase 3", color: "#FBC02D" },
];

export const RemediationFunnel = ({ data, deadline }) => {
  const chartData = PHASES.map((p) => ({
    name: `${p.label} (${data?.[p.key]?.months || ""} mo)`,
    value: data?.[p.key]?.gaps || 0,
    fill: p.color,
  }));
  const hasGaps = chartData.some((d) => d.value > 0);

  return (
    <GrcCard
      title="Remediation Funnel"
      info="Phased remediation roadmap: Critical gaps in 0–6 months, Major in 6–12, Minor in 12–18 — all before the compliance deadline."
      testId="remediation-funnel-widget"
    >
      {hasGaps ? (
        <div className="h-36" data-testid="remediation-funnel-chart">
          <ResponsiveContainer width="100%" height="100%">
            <FunnelChart>
              <Tooltip
                formatter={(v) => [`${v} gaps`, ""]}
                contentStyle={{ fontSize: 11, borderRadius: 8 }}
              />
              <Funnel dataKey="value" data={chartData} isAnimationActive={false}>
                <LabelList position="right" fill="#475569" stroke="none" dataKey="value" fontSize={11} />
              </Funnel>
            </FunnelChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="py-6 text-center text-xs text-slate-400" data-testid="funnel-no-gaps">
          No open gaps — nothing to remediate
        </div>
      )}
      <div className="mt-2 space-y-1.5">
        {PHASES.map((p) => {
          const phase = data?.[p.key] || {};
          return (
            <div key={p.key} className="flex items-center justify-between text-[11px]" data-testid={`funnel-row-${p.key}`}>
              <span className="flex items-center gap-1.5 text-slate-600">
                <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: p.color }} />
                {p.label} · {phase.months} mo
              </span>
              <span className="text-slate-500">
                <span className="font-semibold text-slate-800 tabular-nums">{phase.gaps ?? 0}</span> gaps · due {fmtDate(phase.deadline)}
              </span>
            </div>
          );
        })}
      </div>
      <p className="mt-3 pt-2 border-t border-slate-100 text-[10px] font-semibold text-[#003366]" data-testid="funnel-deadline-marker">
        Compliance Deadline: {fmtDate(deadline)}
      </p>
    </GrcCard>
  );
};
